/* jshint node:true */
'use strict';

module.exports = require('os').EOL